exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".childrenDiv {\n  background-color: #dee3e6;\n  padding-top: 1em;\n  padding-right: 1em;\n  padding-left: 1em;\n  margin-bottom: 2em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/clm-claim/clm-claim.component.scss
// module id = ../../../../../src/app/components/claim/clm-claim/clm-claim.component.scss
// module chunks = main